export default __webpack_public_path__ + "static/media/image10.9fa77e5b.jpg";